<template>
    <div>
        <app-layout-align
            :data-source="'tecpage.user.menus.' + menuId + '.layout.align'"
            :options="getActiveMenuLayoutAlign"
            :data-default="{ type: 'first' }"
        ></app-layout-align>

        <app-layout-type
            :data-source="'tecpage.user.menus.' + menuId + '.layout.type'"
            :options="getActiveMenuLayoutTypes"
            :data-default="{ type: 'random' }"
        ></app-layout-type>

        <app-select
            label="Verhalten"
            :data-source="'tecpage.user.menus.' + menuId + '.layout.position'"
            :data-default="{ type: 'raw', value: 'auto' }"
            :options="{ auto: 'Dynamischer Header', fix: 'Fixierter Header' }"
            hide-clear
            required
        ></app-select>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import LayoutAlign from '@/components/fields/simple/LayoutAlign.vue';
import LayoutType from '@/components/fields/simple/LayoutType.vue';
import Select from '@/components/fields/simple/Select.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getActiveMenuLayoutTypes', 'getActiveMenuLayoutAlign'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R011'),
            help: this.$helpers.uiText('R012'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        menuId: String
    },
    components: {
        'app-text': Text,
        'app-layout-align': LayoutAlign,
        'app-layout-type': LayoutType,
        'app-select': Select
    }
};
</script>
